import React, { useState, useEffect } from 'react'
import Header from '../../../common/header/Header'
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Get_Pooja_Detail, Get_Pooja_App_Details } from '../../../../api/pooja/Pooja';
import Loader from '../../../../loader/Loader';
import { IMG_BASE_URL, WEB_DOMAIN_KEY } from '../../../../config/Config';
import Home_Private_Confidential from "../../home_page_components/home_private_confidential/Home_Private_Confidential"
import Footer from "../../../common/footer/Footer"
import { User_Authentication } from '../../../../user_authentication/User_Authentication';
import parse from 'html-react-parser';
import CalendarTimePicker from '../CalendarTimePicker'
import { Helmet } from 'react-helmet';
import Common_Images_Transport from '../../../common/common_imges_transport/Common_Images_Transport';

const Book_Pooja_Details = () => {
    const navigate = useNavigate();
    const location = useLocation()
    const [isOpen, setIsOpen] = useState(false);

    const { slug } = useParams()
    const [pooja, set_Pooja] = useState({});
    const [pooja_detail, set_Pooja_Detail] = useState([]);
    const [pooja_faqs, set_Pooja_Faqs] = useState([]);
    const [pooja_package, set_Pooja_Package] = useState([]);
    const [isLoading, setIsLoading] = useState(false)
    const Get_user_is_active = localStorage.getItem("user_is_active")
    const [calenderPopup, set_CalenderPopup] = useState(false)
    const [activeAccordion, setActiveAccordion] = useState(null);
    const [selectedPkg, setSelectedPkg] = useState(null);
    const [packageDetail, setPackageDetail] = useState(null);

    const [selectedDateTime, setSelectedDateTime] = useState({
        date: null,
        time: null
    });

    const handleDateTimeChange = ({ date, time }) => {
        setSelectedDateTime({ date, time });
    };

    const toggleAccordion = (id) => {
        setActiveAccordion(id === activeAccordion ? null : id);
    };

    useEffect(() => {
        const fetchPoojaDetail = async () => {
            setIsLoading(true);
            try {
                let response;

                // Handle Authenticated or Guest user logic
                if (Get_user_is_active) {
                    const token = User_Authentication();
                    if (!token) {
                        throw new Error("User token not found");
                    }

                    response = await Get_Pooja_App_Details(slug, {
                        Authorization: `Bearer ${token}`,
                    });

                } else {
                    response = await Get_Pooja_Detail(slug,);
                }

                // Handle response
                const resData = response?.data || response?.response?.data;

                if (resData?.status == 200) {
                    const pooja = resData?.data;
                    set_Pooja(pooja);
                    set_Pooja_Detail(resData?.data?.pooja_list);
                    set_Pooja_Faqs(resData?.data?.pooja_list?.pooja_faq || []);
                    set_Pooja_Package(resData?.data?.pooja_list?.pooja_package || []);

                } else {
                    console.warn("Unexpected status code:", resData?.status);
                }
            } catch (error) {
                console.error(" Error fetching pooja detail:", error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchPoojaDetail();
    }, [slug, Get_user_is_active]);

    const handleCalenderPopUp = (pkg_result) => {
        set_CalenderPopup(true)
        setSelectedPkg(pkg_result);

    }

    const handleCloseCalender = ()=> {
        set_CalenderPopup(false)
        setSelectedPkg(null);
    }

    const handleCalendarConfirm = ({ date, time, muhuratInfo }) => {
        set_CalenderPopup(false); // Close popup

        // Proceed to navigate with all data
        navigate('/pandit-consultant', {
            state: {
                category_id: pooja_detail?.category_id,
                id: pooja_detail?.id,
                package_price: selectedPkg?.amount,
                title: pooja_detail?.name,
                image: pooja_detail?.image,
                description: pooja_detail?.description,
                short_description: pooja_detail?.short_description,
                package: selectedPkg?.packages,
                pooja_id: pooja_detail?.id,
                package_detail: selectedPkg,
                package_name: selectedPkg?.id,
                selected_date: date.toLocaleDateString('en-CA'),
                selected_time: time,
                muhurat_info: muhuratInfo
            }
        });
    };

    const handlePackageDetail = (pkgDetail) => {
        setPackageDetail(pkgDetail)
        setIsOpen(true)
    }

    const bgColors = [
        { className: "bg-red-100", svgColor: "#FEE2E2" },
        { className: "bg-blue-100", svgColor: "#DBEAFE" },
        { className: "bg-yellow-100", svgColor: "#FEF9C3" },
        { className: "bg-green-100", svgColor: "#dcfce7" },
        { className: "bg-purple-200", svgColor: "#E9D5FF" },
    ];

    return (
        <div>
            <Helmet>
                <title>{pooja_detail?.meta_title}</title>
                <meta name="description" content={pooja_detail?.meta_description} />
                <link rel="canonical" href={`${WEB_DOMAIN_KEY}pooja-detail/${pooja_detail?.slug}`} />
                <link rel="alternate" hreflang="en-us" href={`${WEB_DOMAIN_KEY}pooja-detail/${pooja_detail?.slug}`} />
            </Helmet>
            {/*  */}
            <Header />
            {
                isLoading ? (
                    <Loader />
                ) : (
                    <>
                        <section className="gi-single-product py-[40px] max-[767px]:py-[30px]">
                            <div
                                className="flex flex-wrap justify-between items-center mx-auto min-[1400px]:max-w-[1320px] min-[1200px]:max-w-[1140px] min-[992px]:max-w-[960px] min-[768px]:max-w-[720px] min-[576px]:max-w-[540px]">
                                <div className="flex flex-wrap w-full px-[12px]">
                                    <div class="w-full inline-block mb-5">
                                        <ul class="flex flex-wrap items-center gap-2">

                                            <li class="text-gray-700 capitalize"><div class="text-[12px] font-medium cursor-pointer" onClick={() => {
                                                navigate(`/pooja/${pooja_detail?.pooja_category?.slug}`)
                                            }}  >{pooja_detail?.pooja_category?.title}</div></li>
                                            <li class="text-gray-700 text-[12px]">/</li>
                                            <li class="text-red-600 !text-[12px] !font-bold">{pooja_detail?.name}</li>
                                        </ul>
                                    </div>
                                    <div className="gi-pro-rightside gi-common-rightside w-full">
                                        {/* <!-- Single product content Start --> */}
                                        <div className="single-pro-block">
                                            <div className="single-pro-inner">
                                                <div className="grid md:grid-cols-2 gap-4 w-full">
                                                    <div
                                                        className="single-pro-img single-pro-img-no-sidebar px-6 md:px-16 shadow-red-200/50 hover:shadow-cyan-100/50 relative">
                                                        <div className="single-product-scroll sticky top-[30px]">
                                                            <div className="single-product-cover overflow-hidden cursor-zoom-in">
                                                                <div className="single-slide zoom-image-hoverd">
                                                                    {/* <img className="img-responsive h-[400px] w-full rounded-[5px]"
                                                                        src={`${IMG_BASE_URL}${pooja_list?.pooja_list?.image}`} alt="" /> */}
                                                                    <img className='size-96 w-full bg-center bg-contain rounded-lg' src={`${IMG_BASE_URL}${pooja_detail?.image}`} alt={pooja_detail?.image_alt ? pooja_detail?.image_alt : "pooja_image"} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div
                                                        className="relative">
                                                        <div className="single-pro-content">
                                                            <div>
                                                                <h1 className="text-3xl text-gray-900 bodonibook_font font-normal">
                                                                    {pooja_detail?.name}
                                                                </h1>
                                                                <div class="flex gap-2 items-center">
                                                                    <div class="relative py-2 inline-block"
                                                                    >
                                                                        {[...Array(5)].map((_, i) => {
                                                                            const full = Math.floor(pooja?.avg_rating);
                                                                            const isHalf = pooja?.avg_rating - full >= 0.5 && i === full;

                                                                            return (
                                                                                <span key={i} className="relative inline-block text-[14px] mr-[3px] w-[13px] h-[13px]">
                                                                                    <i className="gicon gi-star text-gray-300 absolute top-0 left-0 w-full h-full" />
                                                                                    {i < full && (
                                                                                        <i className="gicon gi-star text-yellow-400 absolute top-0 left-0 w-full h-full" />
                                                                                    )}
                                                                                    {isHalf && (
                                                                                        <i
                                                                                            className="gicon gi-star text-yellow-400 absolute top-0 left-0 w-full h-full overflow-hidden"
                                                                                            style={{ width: '50%' }}
                                                                                        />
                                                                                    )}
                                                                                </span>
                                                                            );
                                                                        })}

                                                                        <span className="font-semibold text-[14px] text-white bg-red-400 px-3 rounded-full">
                                                                            {pooja?.avg_rating > 0 ? pooja?.avg_rating.toFixed(1) : "0.0"}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                                <div className="mb-[13px] text-gray-700 text-[14px] font-medium">
                                                                    {pooja_detail?.short_description}
                                                                </div>

                                                                {pooja_package?.length > 0 && (
                                                                    <div>
                                                                        <h2 className='mb-[13px] text-gray-700 text-xl font-semibold'>Puja Packages</h2>
                                                                        <div className=' overflow-x-auto thin-scrollbar'>
                                                                            <div className='flex gap-3 p-3'>
                                                                                {pooja_package?.length > 0 &&
                                                                                    pooja_package?.map((pkg_result, index) => {
                                                                                        const { className, svgColor } = bgColors[index % bgColors.length];
                                                                                        return (
                                                                                            <div className='relative shadow-xl bg-white shadow-red-900/10 overflow-hidden rounded min-w-[230px] flex flex-col border border-gray-300'>
                                                                                                <div className={`relative ${className}`}>
                                                                                                    <div className='absolute bottom-[-60px] left-0 z-10'>
                                                                                                        <svg
                                                                                                            className='w-full'
                                                                                                            height='122'
                                                                                                            viewBox='0 0 534 122'
                                                                                                            fill='none'
                                                                                                            xmlns='http://www.w3.org/2000/svg'
                                                                                                        >
                                                                                                            <path
                                                                                                                d='M0 97.5001V0H533.333V97.5001C488.889 65.4241 444.444 65.4241 400 97.5001C355.556 129.576 311.111 129.576 266.667 97.5001C222.222 65.4241 177.778 65.4241 133.333 97.5001C88.8889 129.576 44.4444 129.576 0 97.5001Z'
                                                                                                                fill={svgColor}
                                                                                                            />
                                                                                                        </svg>
                                                                                                    </div>
                                                                                                    <div className='relative text-center p-4 z-20'>
                                                                                                        <div className='text-gray-800 font-semibold text-sm'>{pkg_result?.name}</div>
                                                                                                        <h3 className='text-gray-900 font-bold text-lg'>₹ {pkg_result?.amount}</h3>
                                                                                                    </div>
                                                                                                </div>

                                                                                                <div className='p-4 mt-4 flex flex-col flex-1'>
                                                                                                    <ul className='text-[12px]/8 text-gray-900 font-medium'>
                                                                                                        {pkg_result?.packages?.length > 0 &&
                                                                                                            pkg_result?.packages?.map((list_item) => (
                                                                                                                <li key={list_item?.id}>
                                                                                                                    {list_item?.is_included ? (
                                                                                                                        <i className='gicon bg-green-100 mr-2 gi-check rounded-full text-center py-1 w-[20px] h-[20px] text-[10px] font-black text-green-700'></i>
                                                                                                                    ) : (
                                                                                                                        <i className='gicon bg-gray-200 mr-2 gi-close rounded-full text-center py-1 w-[20px] h-[20px] text-[10px] font-black text-gray-900'></i>
                                                                                                                    )}
                                                                                                                    {list_item?.item_name}
                                                                                                                </li>
                                                                                                            ))}

                                                                                                        <li>Days = {pkg_result?.number_of_day}</li>
                                                                                                        <li>Pandits = {pkg_result?.number_of_pandit}</li>
                                                                                                        <li>Duration = {pkg_result?.duration}</li>
                                                                                                    </ul>
                                                                                                    {/* <div className='mt-auto flex flex-col gap-2'></div> */}
                                                                                                    <hr />
                                                                                                    <div className='flex flex-row mt-2 justify-start items-center text-center' onClick={() => handlePackageDetail(pkg_result)}>
                                                                                                        <button type='button' className='inline text-[12px] text-red-700 cursor-pointer font-semibold pr-2' >Know More</button>
                                                                                                        <p class="w-4 h-4 relative "><img src={Common_Images_Transport?.knowMoreArrow} alt="Right arrow button with circle" loading="lazy" class="w-full h-full cursor-pointer object-cover" title="BookMyPooja" /></p>
                                                                                                    </div>

                                                                                                    {/* Pushes button to bottom */}
                                                                                                    <button
                                                                                                        className='mt-auto text-[13px] uppercase w-full text-center border border-gray-300 hover:border-red-700 inline-block text-gray-900 hover:text-white rounded-lg font-semibold px-6 py-2.5 cursor-pointer hover:bg-red-700'
                                                                                                        onClick={() => {
                                                                                                            setSelectedPkg(pkg_result);
                                                                                                            set_CalenderPopup(true);
                                                                                                        }}
                                                                                                    >
                                                                                                        Book Now
                                                                                                    </button>
                                                                                                </div>
                                                                                            </div>
                                                                                        );
                                                                                    })}
                                                                            </div>

                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {/* <!--Single product content End --> */}
                                        <div
                                            className="w-full py-12">
                                            <div className="grid grid-cols-1 gap-5">
                                                <div className="bg-white">
                                                    {pooja_detail?.description && parse(pooja_detail?.description)}

                                                </div>
                                            </div>
                                            {pooja_faqs?.length > 0 && (
                                                <div className="grid grid-cols-1 gap-5">
                                                    <div className="bg-white ">
                                                        <div className='my-3'><h2 className='font-semibold text-xl'>FAQ (Frequently Asked Questions)</h2></div>
                                                        <div id="accordion-collapse" data-accordion="collapse">
                                                            {pooja_faqs?.map((faq_result) => (
                                                                <>
                                                                    <div id="accordion-collapse-heading-1" onClick={() => toggleAccordion(faq_result?.id)}>
                                                                        <button type="button" className="flex items-center justify-between w-full border-b border-gray-300 py-3 font-semibold text-[14px] focus:outline-0" data-accordion-target="#accordion-collapse-body-1" aria-expanded="true" aria-controls="accordion-collapse-body-1">
                                                                            <span>{faq_result?.question}</span>
                                                                            <svg data-accordion-icon className={`size-2 shrink-0 ${activeAccordion == faq_result?.id ? 'rotate-0' : 'rotate-180'}`} aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 6">
                                                                                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5 5 1 1 5" />
                                                                            </svg>
                                                                        </button>
                                                                    </div>
                                                                    <div id="accordion-collapse-body-1" className={`${activeAccordion == faq_result?.id ? 'block' : 'hidden'}`} aria-labelledby="accordion-collapse-heading-1">
                                                                        <div className="py-3 pt-1">

                                                                            <div className="w-full">
                                                                                <div id="gi-spt-nav-info" className="tab-single-pane">
                                                                                    <div className="sub__title text-gray-800 text-[13px] font-medium" dangerouslySetInnerHTML={{ __html: ` ${faq_result?.answer} ` }} />

                                                                                </div>
                                                                            </div>

                                                                        </div>
                                                                    </div>
                                                                </>
                                                            ))}
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                        {/*  */}
                        {/* <Book_Pooja_Details_Testimonals data={pooja_list?.pooja_reviews} /> */}
                        {/*  */}
                        <Home_Private_Confidential />
                        {/*  */}
                        <Footer />
                        {calenderPopup && (
                            <CalendarTimePicker onClose={handleCloseCalender}
                                onConfirm={handleCalendarConfirm} />

                        )}
                        {isOpen && (
                            <div className="fixed inset-0 flex items-center justify-end bg-black/50 z-50">
                                <div className="relative bg-white tran rounded-l-2xl shadow-xl p-6 w-[90%] max-w-md max-h-[90vh] overflow-y-auto thin-scrollbar ">
                                    {/* Close Button */}
                                    <button
                                        onClick={() => setIsOpen(false)}
                                        className="absolute top-3 right-3 text-gray-400 hover:text-gray-600"
                                    >
                                        X
                                    </button>

                                    {/* Title */}
                                    <h2 className="text-xl font-semibold text-gray-800">
                                        {pooja_detail?.name}
                                    </h2>

                                    {/* Price */}
                                    <p className="text-sm text-red-700 font-semibold mt-2">{packageDetail?.name}</p>
                                    <p className="text-2xl font-bold text-gray-900">₹ {packageDetail?.amount}</p>

                                    {/* Inclusions */}
                                    <div className="mt-4">
                                        <h3 className="font-medium text-gray-700 mb-2">Inclusions</h3>
                                        <div className="grid grid-cols-2 gap-y-3">
                                            {packageDetail?.packages?.length > 0 &&
                                                packageDetail?.packages?.map((list_item) => (
                                                    <div key={list_item?.id} className="flex items-center gap-2 text-sm">
                                                        {list_item.is_included ? (
                                                            <div className="w-6 h-6 rounded-full bg-red-800 flex items-center justify-center text-white">
                                                                <i className='gicon bg-green-100 mr-2 gi-check rounded-full text-center py-1 w-[20px] h-[20px] text-[10px] font-black text-green-700'></i>
                                                            </div>
                                                        ) : (
                                                            <div className="w-6 h-6 rounded-full bg-gray-300 flex items-center justify-center text-white">
                                                                <i className='gicon bg-gray-200 mr-2 gi-close rounded-full text-center py-1 w-[20px] h-[20px] text-[10px] font-black text-gray-900'></i>
                                                            </div>
                                                        )}
                                                        <span className="text-gray-700">{list_item.item_name}</span>
                                                    </div>
                                                ))}
                                        </div>
                                    </div>

                                    {/* Other Details */}
                                    <div className="mt-4 text-sm text-gray-700">
                                        {packageDetail?.number_of_day && (
                                            <p>No of Days: <span className="font-semibold">{packageDetail?.number_of_day}</span></p>

                                        )}
                                        {packageDetail?.number_of_pandit && (
                                            <p>No of Pandits: <span className="font-semibold">{packageDetail?.number_of_pandit}</span></p>

                                        )}
                                        {packageDetail?.duration && (
                                            <p>Duration: <span className="font-semibold">{packageDetail?.duration}</span></p>

                                        )}

                                    </div>

                                    {/* Note Section */}
                                    {packageDetail?.notes && (
                                        <p className="mt-4 text-sm font-semibold text-red-800 leading-relaxed">
                                            Note: {packageDetail?.notes}
                                        </p>
                                    )}

                                    {/* Procedure Section */}
                                    <div className="sub__title text-gray-800 text-[13px] font-medium" dangerouslySetInnerHTML={{ __html: ` ${packageDetail?.procedure_involved} ` }} />

                                </div>
                            </div>
                        )}

                    </>
                )
            }

        </div>
    )
}

export default Book_Pooja_Details